module.exports = __webpack_public_path__ + "static/fonts/Montserrat500italic.97573fc8.ttf";